var styles = {
  global: () => ({
    body: {
      fontFamily: 'body',
      color: 'black',
      bg: 'white',
      transition: 'background-color 0.2s',
      lineHeight: 'base'
    },
    '*::placeholder': {
      color: 'grey.400'
    },
    '*, *::before, &::after': {
      borderColor: 'gray.200',
      wordWrap: 'break-word'
    },
    button: {
      fontFamily: 'inherit'
    }
  })
};
export default styles;